<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <b-tabs v-model="activeTab" position="is-centered">
        <b-tab-item
          icon="user"
          :label="$t('layAuthModal.title-1')"
          value="connection"
        >
          <div class="box-red" v-if="connectionError">
            {{ connectionError }}
          </div>
          <br v-if="connectionError" />
          <form @submit.prevent="login()">
            <b-field :label="$t('layAuthModal.label-1') + ' *'">
              <b-input
                v-model="connectUser.email"
                required="required"
                type="email"
                :placeholder="$t('layAuthModal.label-1') + ' *'"
              >
              </b-input>
            </b-field>
            <b-field :label="$t('layAuthModal.label-2') + ' *'">
              <b-input
                v-model="connectUser.password"
                type="password"
                required="required"
                :placeholder="$t('layAuthModal.label-2') + ' *'"
                password-reveal
              ></b-input>
            </b-field>
            <button class="button is-primary is-fullwidth" type="submit">
              <span class="icon is-small"
                ><i class="fa fa-paper-plane"></i
              ></span>
              <span>{{ $t('layAuthModal.title-1') }}</span>
            </button>
            <br />
            <p class="has-text-centered">
              <router-link
                v-on:click.native="resetPassword()"
                class="link"
                :to="{ name: 'reset-password' }"
              >
                {{ $t('layAuthModal.label-4') }}
              </router-link>
            </p>
          </form>
        </b-tab-item>
        <b-tab-item
          icon="pencil"
          :label="$t('layAuthModal.title-2')"
          value="registration"
        >
          <b-notification v-if="linkSent" :closable="false">
            <span v-html="$t('layAuthModal.msg-1')" />
          </b-notification>
          <div v-else>
            <div class="box-red" v-if="registrationError">
              {{ registrationError }}
            </div>
            <br v-if="registrationError" />
            <form @submit.prevent="signIn()">
              <b-field label="Email *">
                <b-input
                  v-model="registertUser.email"
                  type="email"
                  placeholder="Email *"
                >
                </b-input>
              </b-field>
              <b-field :label="$t('layAuthModal.label-2') + ' *'">
                <b-input
                  v-model="registertUser.password1"
                  type="password"
                  :placeholder="$t('layAuthModal.label-2') + ' *'"
                >
                </b-input>
              </b-field>
              <b-field :label="$t('layAuthModal.label-3') + ' *'">
                <b-input
                  v-model="registertUser.password2"
                  type="password"
                  @keydown.enter="validate"
                  :placeholder="$t('layAuthModal.label-3') + ' *'"
                >
                </b-input>
              </b-field>
              <button class="button is-primary is-fullwidth" type="submit">
                <span class="icon is-small"
                  ><i class="fa fa-paper-plane"></i
                ></span>
                <span>{{ $t('layAuthModal.title-2') }}</span>
              </button>
            </form>
          </div>
        </b-tab-item>
      </b-tabs>
    </section>
  </div>
</template>

<script>
import authenticationService from '@/services/authenticationService'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'AuthModal',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      linkSent: false,
      activeTab: 'connection',
      connectUser: {
        email: null,
        password: null
      },
      registertUser: {
        email: null,
        password1: null,
        password2: null
      },
      connectionError: '',
      registrationError: ''
    }
  },
  setup () {
    const authStore = useAuthenticationStore()
    return { authStore }
  },
  methods: {
    resetPassword () {
      this.$parent.close()
    },
    resetConnectionForm () {
      this.connectUser = {
        email: null,
        password: null
      }
      this.connectionError = ''
    },
    resetRegistrationForm () {
      this.registertUser = {
        email: null,
        password1: null,
        password2: null
      }
      this.registrationError = ''
    },
    login () {
      this.connectUser.email = this.connectUser.email.toLowerCase()
      let { email, password } = this.connectUser
      this.authStore
        .authRequest({ email, password })
        .then(() => {
          this.$parent.close()
        })
        .catch((erreur) => {
          if ('detail' in erreur.response.data) {
            if (
              erreur.response.data.detail ===
              'No active account found with the given credentials'
            ) {
              this.connectionError = this.$t('layAuthModal.msg-4')
            } else {
              this.connectionError = erreur.response.data
            }
          } else {
            this.connectionError = erreur.response.data
          }
        })
    },
    signIn () {
      this.registertUser.email = this.registertUser.email.toLowerCase()
      authenticationService
        .register(this.registertUser)
        .then((data) => {
          this.linkSent = true
        })
        .catch((erreur) => {
          if ('email' in erreur.response.data) {
            this.registrationError = this.$t('layAuthModal.msg-2')
          } else if ('non_field_errors' in erreur.response.data) {
            this.registrationError = this.$t('layAuthModal.msg-3')
          } else {
            this.registrationError = erreur.response.data
          }
        })
    }
  },
  watch: {
    activeTab: function () {
      if (this.activeTab === 'connection') {
        this.resetRegistrationForm()
      } else {
        this.resetConnectionForm()
      }
    }
  }
}
</script>
